import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import { isAxiosError } from 'axios'
import type { User } from '@/modules/auth/model'

export class NonActionableWarning extends Error {
    constructor(message: string) {
        super(message)
    }
}

function isActionable(error: unknown) {
    if (error instanceof NonActionableWarning) {
        return false
    }
    if (isAxiosError(error)) {
        const status = error.response?.status ?? 0
        return status >= 500
    }

    return true
}

export function setupSentry(app: App) {
    const hostname = window.location.hostname

    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: hostname.includes('.staging.') ? 'staging' : 'production',
        tracesSampleRate: 2.0,
        enabled: import.meta.env.MODE !== 'development',
        integrations: [Sentry.browserTracingIntegration()],
        beforeSend: (event, hint) => {
            // prevent event on localhost
            if (hostname === 'localhost') {
                return null
            }

            if (!isActionable(hint.originalException)) {
                event.level = 'warning'
            }

            return event
        },
    })
}

export function updateSentryContext(user?: User) {
    Sentry.setUser({ id: user?.id, email: user?.email })
}
